<h1 mat-dialog-title>
  {{ title }}
</h1>
<div mat-dialog-content>
  <p>
    {{ body }}
  </p>
  <p>
    {{ inputInstruction }}
  </p>

  <mat-form-field class="full-width">
    <input
      matInput
      [formControl]="confirmationControl"
      type="text"
      autocorrect="off"
      autocapitalize="off"
    />
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button ca-action-button mat-dialog-close cdkFocusInitial>
    {{ cancel }}
  </button>
  <button
    [disabled]="confirmationControl.value?.toLowerCase() !== 'confirm'"
    mat-dialog-close
    ca-action-button
    [color]="confirmColor"
    (click)="confirmAction()"
  >
    {{ confirm }}
  </button>
</div>
